import React from 'react';
import { IconProps } from '../types';
const MinecraftEchoShard: React.FC<IconProps> = ({ size = 24, className, style }) => (
<svg width={size} height={size} className={className} style={style} viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
<rect x="2" y="1" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="3" y="1" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="1" y="2" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="2" y="2" width="1" height="1" fill="rgba(3, 65, 80, 255)" />
<rect x="3" y="2" width="1" height="1" fill="rgba(10, 80, 96, 255)" />
<rect x="4" y="2" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="5" y="2" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="1" y="3" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="2" y="3" width="1" height="1" fill="rgba(10, 80, 96, 255)" />
<rect x="3" y="3" width="1" height="1" fill="rgba(10, 80, 96, 255)" />
<rect x="4" y="3" width="1" height="1" fill="rgba(0, 146, 149, 255)" />
<rect x="5" y="3" width="1" height="1" fill="rgba(10, 80, 96, 255)" />
<rect x="6" y="3" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="1" y="4" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="2" y="4" width="1" height="1" fill="rgba(3, 65, 80, 255)" />
<rect x="3" y="4" width="1" height="1" fill="rgba(0, 146, 149, 255)" />
<rect x="4" y="4" width="1" height="1" fill="rgba(41, 223, 235, 255)" />
<rect x="5" y="4" width="1" height="1" fill="rgba(0, 146, 149, 255)" />
<rect x="6" y="4" width="1" height="1" fill="rgba(10, 80, 96, 255)" />
<rect x="7" y="4" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="1" y="5" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="2" y="5" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="3" y="5" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="4" y="5" width="1" height="1" fill="rgba(0, 146, 149, 255)" />
<rect x="5" y="5" width="1" height="1" fill="rgba(10, 80, 96, 255)" />
<rect x="6" y="5" width="1" height="1" fill="rgba(3, 65, 80, 255)" />
<rect x="7" y="5" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="8" y="5" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="1" y="6" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="2" y="6" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="3" y="6" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="4" y="6" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="5" y="6" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="6" y="6" width="1" height="1" fill="rgba(3, 65, 80, 255)" />
<rect x="7" y="6" width="1" height="1" fill="rgba(3, 65, 80, 255)" />
<rect x="8" y="6" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="9" y="6" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="2" y="7" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="3" y="7" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="4" y="7" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="5" y="7" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="6" y="7" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="7" y="7" width="1" height="1" fill="rgba(10, 80, 96, 255)" />
<rect x="8" y="7" width="1" height="1" fill="rgba(3, 65, 80, 255)" />
<rect x="9" y="7" width="1" height="1" fill="rgba(3, 65, 80, 255)" />
<rect x="10" y="7" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="3" y="8" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="4" y="8" width="1" height="1" fill="rgba(10, 80, 96, 255)" />
<rect x="5" y="8" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="6" y="8" width="1" height="1" fill="rgba(3, 65, 80, 255)" />
<rect x="7" y="8" width="1" height="1" fill="rgba(0, 146, 149, 255)" />
<rect x="8" y="8" width="1" height="1" fill="rgba(10, 80, 96, 255)" />
<rect x="9" y="8" width="1" height="1" fill="rgba(3, 65, 80, 255)" />
<rect x="10" y="8" width="1" height="1" fill="rgba(3, 65, 80, 255)" />
<rect x="11" y="8" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="4" y="9" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="5" y="9" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="6" y="9" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="7" y="9" width="1" height="1" fill="rgba(3, 65, 80, 255)" />
<rect x="8" y="9" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="9" y="9" width="1" height="1" fill="rgba(3, 65, 80, 255)" />
<rect x="10" y="9" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="11" y="9" width="1" height="1" fill="rgba(3, 65, 80, 255)" />
<rect x="12" y="9" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="5" y="10" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="6" y="10" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="7" y="10" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="8" y="10" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="9" y="10" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="10" y="10" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="11" y="10" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="12" y="10" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="13" y="10" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="6" y="11" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="7" y="11" width="1" height="1" fill="rgba(3, 65, 80, 255)" />
<rect x="8" y="11" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="9" y="11" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="10" y="11" width="1" height="1" fill="rgba(3, 65, 80, 255)" />
<rect x="11" y="11" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="12" y="11" width="1" height="1" fill="rgba(10, 80, 96, 255)" />
<rect x="13" y="11" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="7" y="12" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="8" y="12" width="1" height="1" fill="rgba(10, 80, 96, 255)" />
<rect x="9" y="12" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="10" y="12" width="1" height="1" fill="rgba(17, 27, 33, 255)" />
<rect x="11" y="12" width="1" height="1" fill="rgba(10, 80, 96, 255)" />
<rect x="12" y="12" width="1" height="1" fill="rgba(0, 146, 149, 255)" />
<rect x="13" y="12" width="1" height="1" fill="rgba(10, 80, 96, 255)" />
<rect x="14" y="12" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="8" y="13" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="9" y="13" width="1" height="1" fill="rgba(0, 146, 149, 255)" />
<rect x="10" y="13" width="1" height="1" fill="rgba(3, 65, 80, 255)" />
<rect x="11" y="13" width="1" height="1" fill="rgba(5, 42, 50, 255)" />
<rect x="12" y="13" width="1" height="1" fill="rgba(10, 80, 96, 255)" />
<rect x="13" y="13" width="1" height="1" fill="rgba(3, 65, 80, 255)" />
<rect x="14" y="13" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="9" y="14" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="10" y="14" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="11" y="14" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="12" y="14" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
<rect x="13" y="14" width="1" height="1" fill="rgba(13, 18, 23, 255)" />
</svg>);
export default MinecraftEchoShard;